import * as z from "zod";

export const RecognizeAudienceOrderCount = z.object({
  min: z.number().int().nonnegative(),
});

export type RecognizeAudienceOrderCount = z.infer<
  typeof RecognizeAudienceOrderCount
>;
